import { ElementRef, TemplateRef } from '@angular/core';
import { SRQCompletedService } from '../srq-completed/srq-completed.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TrackerService } from '../../core/tracker/tracker.service';
import { SessionStorageService } from "ngx-webstorage";
import { WellbeingResultChartComponent } from '../wellbeing-result/wellbeing-result-chart.component';
import { NavbarInukaService } from '../navbar-inuka/navbar-inuka.service';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import { UserService } from '../../core/user/user.service';
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { SelfScanTrendModalComponent } from '../../shared/wellbeing-result/self-scan-trend/self-scan-trend-modal.component';
import { AccountService } from '../../core/auth/account.service';
import { QuestionarreAnswerService } from '../questionarre-answer/questionarre-answer.service';
import { FlowManagerService } from '../../core/util/flow-manager.service';
import { WellbeingScanService } from '../wellbeing-scan/wellbeing-scan.service';
import { TipFromCoachComponent } from '../../shared/tip-from-coach/tip-from-coach.component';
import * as i0 from "@angular/core";
import * as i1 from "../srq-completed/srq-completed.service";
import * as i2 from "../navbar-inuka/navbar-inuka.service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "../../ng-jhipster/language";
import * as i5 from "../../ng-jhipster/service";
import * as i6 from "../../core/tracker/tracker.service";
import * as i7 from "ngx-webstorage";
import * as i8 from "../../core/user/user.service";
import * as i9 from "@angular/platform-browser";
import * as i10 from "@angular/router";
import * as i11 from "../../core/auth/account.service";
import * as i12 from "../questionarre-answer/questionarre-answer.service";
import * as i13 from "../../core/util/flow-manager.service";
import * as i14 from "../wellbeing-scan/wellbeing-scan.service";
import * as i15 from "@angular/common";
import * as i16 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i17 from "@fortawesome/angular-fontawesome";
import * as i18 from "../../shared/resources-for-help/resources-for-help.component";
const _c0 = ["resourcesForHelpModal"];
function WellbeingResultComponent_div_1_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 74);
} }
function WellbeingResultComponent_div_1_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 75);
} }
function WellbeingResultComponent_div_1_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 76);
} }
const _c1 = function (a0) { return { score: a0 }; };
function WellbeingResultComponent_div_1_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 77);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c1, ctx_r7.totalScore));
} }
function WellbeingResultComponent_div_1_span_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 78);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c1, ctx_r8.totalScore));
} }
function WellbeingResultComponent_div_1_span_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 79);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c1, ctx_r9.totalScore));
} }
function WellbeingResultComponent_div_1_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵelement(1, "fa-icon", 81);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(ctx_r10.percentTotalScore <= 70 ? "left:" + ctx_r10.percentTotalScore + "%;padding-left: 5px;" : "right:" + (100 - ctx_r10.percentTotalScore) + "%;padding-right: 5px;");
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("text-success", ctx_r10.isResilient)("text-warning", ctx_r10.isAtRisk)("text-danger", ctx_r10.isAtTough);
} }
function WellbeingResultComponent_div_1_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(ctx_r11.percentTotalScore <= 70 ? "left:" + ctx_r11.percentTotalScore + "%" : "right:" + (100 - ctx_r11.percentTotalScore) + "%");
    i0.ɵɵclassProp("bg-success", ctx_r11.isResilient)("bg-warning", ctx_r11.isAtRisk)("bg-danger", ctx_r11.isAtTough);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r11.totalScore);
} }
function WellbeingResultComponent_div_1_span_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 77);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c1, ctx_r12.totalScore));
} }
function WellbeingResultComponent_div_1_span_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 78);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c1, ctx_r13.totalScore));
} }
function WellbeingResultComponent_div_1_span_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 79);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c1, ctx_r14.totalScore));
} }
function WellbeingResultComponent_div_1_div_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 83);
} }
function WellbeingResultComponent_div_1_div_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 84);
} }
function WellbeingResultComponent_div_1_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 85);
} }
function WellbeingResultComponent_div_1_div_56_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 86);
    i0.ɵɵelementStart(1, "div", 87);
    i0.ɵɵelement(2, "fa-icon", 88);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelement(4, "span", 89);
    i0.ɵɵelementStart(5, "span", 90);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_1_div_56_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.displayResourcesModal(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "span", 91);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WellbeingResultComponent_div_1_ng_template_82_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelement(1, "p", 93);
    i0.ɵɵelementEnd();
} }
function WellbeingResultComponent_div_1_div_87_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "p", 94);
    i0.ɵɵelementStart(2, "div", 95);
    i0.ɵɵelement(3, "span", 96);
    i0.ɵɵelementStart(4, "span", 97);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_1_div_87_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(2); return ctx_r33.openTip(ctx_r33.body); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", "wellBeingResult.moodIndicator.body." + ctx_r21.bodyStage);
} }
function WellbeingResultComponent_div_1_ng_template_99_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelement(1, "p", 98);
    i0.ɵɵelementEnd();
} }
function WellbeingResultComponent_div_1_div_104_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "p", 94);
    i0.ɵɵelementStart(2, "div", 95);
    i0.ɵɵelement(3, "span", 99);
    i0.ɵɵelementStart(4, "span", 97);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_1_div_104_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.openTip(ctx_r35.mood); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", "wellBeingResult.moodIndicator.mood." + ctx_r24.moodStage);
} }
function WellbeingResultComponent_div_1_ng_template_117_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelement(1, "p", 100);
    i0.ɵɵelementEnd();
} }
function WellbeingResultComponent_div_1_div_122_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "p", 94);
    i0.ɵɵelementStart(2, "div", 95);
    i0.ɵɵelement(3, "span", 101);
    i0.ɵɵelementStart(4, "span", 97);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_1_div_122_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(2); return ctx_r37.openTip(ctx_r37.energy); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", "wellBeingResult.moodIndicator.energy." + ctx_r27.energyStage);
} }
function WellbeingResultComponent_div_1_ng_template_134_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelement(1, "p", 102);
    i0.ɵɵelementEnd();
} }
function WellbeingResultComponent_div_1_div_139_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "p", 94);
    i0.ɵɵelementStart(2, "div", 95);
    i0.ɵɵelement(3, "span", 103);
    i0.ɵɵelementStart(4, "span", 97);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_1_div_139_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(2); return ctx_r39.openTip(ctx_r39.purpose); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", "wellBeingResult.moodIndicator.purpose." + ctx_r30.purposeStage);
} }
const _c2 = function (a0) { return { year: a0 }; };
function WellbeingResultComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵelementStart(4, "div", 7);
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 6);
    i0.ɵɵelementStart(9, "div", 9);
    i0.ɵɵelement(10, "span", 10);
    i0.ɵɵtemplate(11, WellbeingResultComponent_div_1_span_11_Template, 1, 0, "span", 11);
    i0.ɵɵtemplate(12, WellbeingResultComponent_div_1_span_12_Template, 1, 0, "span", 12);
    i0.ɵɵtemplate(13, WellbeingResultComponent_div_1_span_13_Template, 1, 0, "span", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 14);
    i0.ɵɵelementStart(15, "div", 15);
    i0.ɵɵelementStart(16, "div", 16);
    i0.ɵɵelementStart(17, "div", 17);
    i0.ɵɵtemplate(18, WellbeingResultComponent_div_1_span_18_Template, 1, 3, "span", 18);
    i0.ɵɵtemplate(19, WellbeingResultComponent_div_1_span_19_Template, 1, 3, "span", 19);
    i0.ɵɵtemplate(20, WellbeingResultComponent_div_1_span_20_Template, 1, 3, "span", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 21);
    i0.ɵɵelementStart(22, "div", 22);
    i0.ɵɵelementStart(23, "span");
    i0.ɵɵtext(24, "0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 23);
    i0.ɵɵtemplate(26, WellbeingResultComponent_div_1_div_26_Template, 2, 8, "div", 24);
    i0.ɵɵelement(27, "div", 25);
    i0.ɵɵtemplate(28, WellbeingResultComponent_div_1_div_28_Template, 2, 9, "div", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 27);
    i0.ɵɵelementStart(30, "span");
    i0.ɵɵtext(31, "20");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "div", 28);
    i0.ɵɵtext(33, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 29);
    i0.ɵɵelementStart(35, "div", 17);
    i0.ɵɵtemplate(36, WellbeingResultComponent_div_1_span_36_Template, 1, 3, "span", 18);
    i0.ɵɵtemplate(37, WellbeingResultComponent_div_1_span_37_Template, 1, 3, "span", 19);
    i0.ɵɵtemplate(38, WellbeingResultComponent_div_1_span_38_Template, 1, 3, "span", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 30);
    i0.ɵɵelementStart(40, "div", 31);
    i0.ɵɵtemplate(41, WellbeingResultComponent_div_1_div_41_Template, 1, 0, "div", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 31);
    i0.ɵɵtemplate(43, WellbeingResultComponent_div_1_div_43_Template, 1, 0, "div", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 31);
    i0.ɵɵtemplate(45, WellbeingResultComponent_div_1_div_45_Template, 1, 0, "div", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "div", 35);
    i0.ɵɵelementStart(47, "div", 36);
    i0.ɵɵelementStart(48, "div", 37);
    i0.ɵɵelementStart(49, "div", 38);
    i0.ɵɵelement(50, "button", 39);
    i0.ɵɵelementStart(51, "button", 40);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_1_Template_button_click_51_listener() { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.navigateToSecondPage(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "div", 41);
    i0.ɵɵelementStart(53, "div", 38);
    i0.ɵɵelement(54, "button", 39);
    i0.ɵɵelementStart(55, "button", 40);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_1_Template_button_click_55_listener() { i0.ɵɵrestoreView(_r42); const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.navigateToSecondPage(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(56, WellbeingResultComponent_div_1_div_56_Template, 7, 0, "div", 42);
    i0.ɵɵelementStart(57, "div", 43);
    i0.ɵɵelementStart(58, "div", 44);
    i0.ɵɵelementStart(59, "a", 45);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_1_Template_a_click_59_listener() { i0.ɵɵrestoreView(_r42); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.openProgressModal(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(60, "svg", 46);
    i0.ɵɵelement(61, "use", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(62, "span", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(63, "div", 38);
    i0.ɵɵelementStart(64, "div", 36);
    i0.ɵɵelementStart(65, "div", 49);
    i0.ɵɵelementStart(66, "div", 9);
    i0.ɵɵelement(67, "h3", 50);
    i0.ɵɵelement(68, "p", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(69, "div", 52);
    i0.ɵɵelementStart(70, "div", 53);
    i0.ɵɵelementStart(71, "div", 54);
    i0.ɵɵelementStart(72, "div", 55);
    i0.ɵɵelementStart(73, "div", 56);
    i0.ɵɵelementStart(74, "span", 57);
    i0.ɵɵelement(75, "span", 58);
    i0.ɵɵelement(76, "fa-icon", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(77, "span");
    i0.ɵɵelementStart(78, "span", 60);
    i0.ɵɵtext(79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(80, "span");
    i0.ɵɵtext(81, "/6");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(82, WellbeingResultComponent_div_1_ng_template_82_Template, 2, 0, "ng-template", null, 61, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(84, "div", 62);
    i0.ɵɵelementStart(85, "div", 63);
    i0.ɵɵelement(86, "div", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(87, WellbeingResultComponent_div_1_div_87_Template, 5, 1, "div", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(88, "div", 66);
    i0.ɵɵelementStart(89, "div", 55);
    i0.ɵɵelementStart(90, "div", 56);
    i0.ɵɵelementStart(91, "span", 57);
    i0.ɵɵelement(92, "span", 67);
    i0.ɵɵelement(93, "fa-icon", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(94, "span");
    i0.ɵɵelementStart(95, "span", 60);
    i0.ɵɵtext(96);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(97, "span");
    i0.ɵɵtext(98, "/4");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(99, WellbeingResultComponent_div_1_ng_template_99_Template, 2, 0, "ng-template", null, 68, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(101, "div", 62);
    i0.ɵɵelementStart(102, "div", 63);
    i0.ɵɵelement(103, "div", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(104, WellbeingResultComponent_div_1_div_104_Template, 5, 1, "div", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(105, "div", 69);
    i0.ɵɵelementStart(106, "div", 54);
    i0.ɵɵelementStart(107, "div", 55);
    i0.ɵɵelementStart(108, "div", 56);
    i0.ɵɵelementStart(109, "span", 57);
    i0.ɵɵelement(110, "span", 70);
    i0.ɵɵelement(111, "fa-icon", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(112, "span");
    i0.ɵɵelementStart(113, "span", 60);
    i0.ɵɵtext(114);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(115, "span");
    i0.ɵɵtext(116, "/6");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(117, WellbeingResultComponent_div_1_ng_template_117_Template, 2, 0, "ng-template", null, 71, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(119, "div", 62);
    i0.ɵɵelementStart(120, "div", 63);
    i0.ɵɵelement(121, "div", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(122, WellbeingResultComponent_div_1_div_122_Template, 5, 1, "div", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(123, "div", 66);
    i0.ɵɵelementStart(124, "div", 55);
    i0.ɵɵelementStart(125, "div", 56);
    i0.ɵɵelementStart(126, "span", 57);
    i0.ɵɵelement(127, "span", 72);
    i0.ɵɵelement(128, "fa-icon", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(129, "span");
    i0.ɵɵelementStart(130, "span", 60);
    i0.ɵɵtext(131);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(132, "span");
    i0.ɵɵtext(133, "/4");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(134, WellbeingResultComponent_div_1_ng_template_134_Template, 2, 0, "ng-template", null, 73, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(136, "div", 62);
    i0.ɵɵelementStart(137, "div", 63);
    i0.ɵɵelement(138, "div", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(139, WellbeingResultComponent_div_1_div_139_Template, 5, 1, "div", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r19 = i0.ɵɵreference(83);
    const _r22 = i0.ɵɵreference(100);
    const _r25 = i0.ɵɵreference(118);
    const _r28 = i0.ɵɵreference(135);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.dateTakenFormatted);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("jhiTranslate", "sessionSchedule.header.months.", (ctx_r0.displayedTestResult == null ? null : ctx_r0.displayedTestResult.dateTaken == null ? null : ctx_r0.displayedTestResult.dateTaken.month()) + 1, "");
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(78, _c2, ctx_r0.displayedTestResult == null ? null : ctx_r0.displayedTestResult.dateTaken == null ? null : ctx_r0.displayedTestResult.dateTaken.year()));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.isAtTough);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isAtRisk);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isResilient);
    i0.ɵɵadvance(4);
    i0.ɵɵclassProp("bg-success", ctx_r0.isResilient)("bg-warning", ctx_r0.isAtRisk)("bg-danger", ctx_r0.isAtTough)("border-success", ctx_r0.isResilient)("border-warning", ctx_r0.isAtRisk)("border-danger", ctx_r0.isAtTough);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isAtTough);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isAtRisk);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isResilient);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r0.percentTotalScore != null);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-valuenow", ctx_r0.percentTotalScore);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.percentTotalScore != null);
    i0.ɵɵadvance(7);
    i0.ɵɵclassProp("bg-success", ctx_r0.isResilient)("bg-warning", ctx_r0.isAtRisk)("bg-danger", ctx_r0.isAtTough)("border-success", ctx_r0.isResilient)("border-warning", ctx_r0.isAtRisk)("border-danger", ctx_r0.isAtTough);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isAtTough);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isAtRisk);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isResilient);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.isAtTough);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.isAtRisk);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.isResilient);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("ngIf", (ctx_r0.q17Answer == null ? null : ctx_r0.q17Answer.answer) === "Yes");
    i0.ɵɵadvance(20);
    i0.ɵɵproperty("ngbPopover", _r19)("closeDelay", 1000);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", "text-" + ctx_r0.bodyStage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.displayedTestResult == null ? null : ctx_r0.displayedTestResult.bodyScore);
    i0.ɵɵadvance(7);
    i0.ɵɵstyleProp("width", ctx_r0.percentBodyScore + "%");
    i0.ɵɵproperty("ngClass", "bg-" + ctx_r0.bodyStage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.bodyStage != null);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngbPopover", _r22)("closeDelay", 1000);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", "text-" + ctx_r0.moodStage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.displayedTestResult == null ? null : ctx_r0.displayedTestResult.moodScore);
    i0.ɵɵadvance(7);
    i0.ɵɵstyleProp("width", ctx_r0.percentMoodScore + "%");
    i0.ɵɵproperty("ngClass", "bg-" + ctx_r0.moodStage);
    i0.ɵɵattribute("aria-valuenow", ctx_r0.percentMoodScore);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.moodStage != null);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngbPopover", _r25)("closeDelay", 1000);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", "text-" + ctx_r0.energyStage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.displayedTestResult == null ? null : ctx_r0.displayedTestResult.energyScore);
    i0.ɵɵadvance(7);
    i0.ɵɵstyleProp("width", ctx_r0.percentEnergyScore + "%");
    i0.ɵɵproperty("ngClass", "bg-" + ctx_r0.energyStage);
    i0.ɵɵattribute("aria-valuenow", ctx_r0.percentEnergyScore);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.energyStage != null);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngbPopover", _r28)("closeDelay", 1000);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", "text-" + ctx_r0.purposeStage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.displayedTestResult == null ? null : ctx_r0.displayedTestResult.outlookScore);
    i0.ɵɵadvance(7);
    i0.ɵɵstyleProp("width", ctx_r0.percentOutlookScore + "%");
    i0.ɵɵproperty("ngClass", "bg-" + ctx_r0.purposeStage);
    i0.ɵɵattribute("aria-valuenow", ctx_r0.percentOutlookScore);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.purposeStage != null);
} }
function WellbeingResultComponent_div_2_div_39_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 169);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_2_div_39_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(2); return ctx_r51.onSwipeLeft(); });
    i0.ɵɵelement(1, "fa-icon", 170);
    i0.ɵɵelement(2, "span", 171);
    i0.ɵɵelementEnd();
} }
function WellbeingResultComponent_div_2_div_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 172);
    i0.ɵɵtext(1, ".");
    i0.ɵɵelementEnd();
} }
function WellbeingResultComponent_div_2_div_41_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 169);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_2_div_41_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(2); return ctx_r53.onSwipeRight(); });
    i0.ɵɵelement(1, "span", 173);
    i0.ɵɵelement(2, "fa-icon", 174);
    i0.ɵɵelementEnd();
} }
function WellbeingResultComponent_div_2_div_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 172);
    i0.ɵɵtext(1, ".");
    i0.ɵɵelementEnd();
} }
function WellbeingResultComponent_div_2_ng_template_194_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 175);
    i0.ɵɵelementStart(1, "div", 176);
    i0.ɵɵelementStart(2, "table", 177);
    i0.ɵɵelementStart(3, "tbody");
    i0.ɵɵelementStart(4, "tr");
    i0.ɵɵelement(5, "td", 178);
    i0.ɵɵelementStart(6, "td", 179);
    i0.ɵɵelement(7, "span", 180);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "tr");
    i0.ɵɵelement(9, "td", 181);
    i0.ɵɵelementStart(10, "td", 179);
    i0.ɵɵelement(11, "span", 182);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "tr");
    i0.ɵɵelement(13, "td", 183);
    i0.ɵɵelementStart(14, "td", 179);
    i0.ɵɵelement(15, "span", 184);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 185);
    i0.ɵɵelementStart(17, "a", 186);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_2_ng_template_194_Template_a_click_17_listener() { const restoredCtx = i0.ɵɵrestoreView(_r57); const modal_r55 = restoredCtx.$implicit; return modal_r55.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WellbeingResultComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 104);
    i0.ɵɵelementStart(2, "div", 105);
    i0.ɵɵelementStart(3, "table", 106);
    i0.ɵɵelementStart(4, "tbody");
    i0.ɵɵelementStart(5, "tr");
    i0.ɵɵelementStart(6, "td", 107);
    i0.ɵɵelementStart(7, "div", 108);
    i0.ɵɵelement(8, "fa-icon", 109);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵelementStart(10, "span", 110);
    i0.ɵɵtext(11, "Welcome to Inuka!");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "br");
    i0.ɵɵelementStart(13, "span", 111);
    i0.ɵɵelementStart(14, "span", 112);
    i0.ɵɵtext(15, "Results on: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "span");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "div", 113);
    i0.ɵɵelementStart(20, "tr");
    i0.ɵɵelementStart(21, "td", 107);
    i0.ɵɵelementStart(22, "div", 108);
    i0.ɵɵelement(23, "fa-icon", 109);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "td");
    i0.ɵɵelementStart(25, "span", 114);
    i0.ɵɵtext(26, "Self Scan");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(27, "br");
    i0.ɵɵelementStart(28, "span", 111);
    i0.ɵɵelementStart(29, "span", 115);
    i0.ɵɵtext(30, "Results on: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "span");
    i0.ɵɵtext(32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "tr", 116);
    i0.ɵɵelementStart(34, "td", 107);
    i0.ɵɵelement(35, "div", 117);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "td");
    i0.ɵɵelementStart(37, "div", 118);
    i0.ɵɵelementStart(38, "div", 119);
    i0.ɵɵtemplate(39, WellbeingResultComponent_div_2_div_39_Template, 3, 0, "div", 120);
    i0.ɵɵtemplate(40, WellbeingResultComponent_div_2_div_40_Template, 2, 0, "div", 121);
    i0.ɵɵtemplate(41, WellbeingResultComponent_div_2_div_41_Template, 3, 0, "div", 120);
    i0.ɵɵtemplate(42, WellbeingResultComponent_div_2_div_42_Template, 2, 0, "div", 121);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "div", 122);
    i0.ɵɵelement(44, "h4", 123);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(45, "div", 124);
    i0.ɵɵlistener("click", function WellbeingResultComponent_div_2_Template_div_click_45_listener() { i0.ɵɵrestoreView(_r59); const _r49 = i0.ɵɵreference(195); const ctx_r58 = i0.ɵɵnextContext(); return ctx_r58.displayInfo(_r49, "ss_results_edu_score_clicked"); });
    i0.ɵɵelementStart(46, "div", 125);
    i0.ɵɵelementStart(47, "span");
    i0.ɵɵtext(48, "0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 126);
    i0.ɵɵelementStart(50, "div", 127);
    i0.ɵɵelementStart(51, "div", 128);
    i0.ɵɵtext(52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "div", 129);
    i0.ɵɵelementStart(54, "span");
    i0.ɵɵtext(55, "20");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(56, "div", 130);
    i0.ɵɵelementStart(57, "div", 131);
    i0.ɵɵelementStart(58, "div", 132);
    i0.ɵɵelement(59, "span", 133);
    i0.ɵɵelement(60, "br");
    i0.ɵɵelement(61, "p", 134);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "div", 132);
    i0.ɵɵelement(63, "span", 135);
    i0.ɵɵelement(64, "br");
    i0.ɵɵelement(65, "p", 136);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(66, "div", 132);
    i0.ɵɵelement(67, "span", 137);
    i0.ɵɵelement(68, "br");
    i0.ɵɵelement(69, "p", 138);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(70, "div", 139);
    i0.ɵɵelementStart(71, "div", 140);
    i0.ɵɵelementStart(72, "div", 141);
    i0.ɵɵelement(73, "span", 133);
    i0.ɵɵelement(74, "br");
    i0.ɵɵelement(75, "p", 134);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(76, "div", 141);
    i0.ɵɵelement(77, "span", 135);
    i0.ɵɵelement(78, "br");
    i0.ɵɵelement(79, "p", 136);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(80, "div", 141);
    i0.ɵɵelement(81, "span", 137);
    i0.ɵɵelement(82, "br");
    i0.ɵɵelement(83, "p", 138);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(84, "div", 142);
    i0.ɵɵelementStart(85, "div", 143);
    i0.ɵɵelementStart(86, "div");
    i0.ɵɵelement(87, "h4", 144);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(88, "div", 145);
    i0.ɵɵelementStart(89, "div", 146);
    i0.ɵɵelement(90, "fa-icon", 147);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(91, "div", 148);
    i0.ɵɵelement(92, "span", 149);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(93, "div", 130);
    i0.ɵɵelementStart(94, "div", 150);
    i0.ɵɵelementStart(95, "div", 151);
    i0.ɵɵelementStart(96, "div", 56);
    i0.ɵɵelement(97, "span", 152);
    i0.ɵɵelementStart(98, "span");
    i0.ɵɵelementStart(99, "span", 153);
    i0.ɵɵtext(100);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(101, "span");
    i0.ɵɵtext(102, "/6");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(103, "div", 154);
    i0.ɵɵelementStart(104, "div", 155);
    i0.ɵɵelement(105, "div", 156);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(106, "div", 151);
    i0.ɵɵelementStart(107, "div", 56);
    i0.ɵɵelement(108, "span", 157);
    i0.ɵɵelementStart(109, "span");
    i0.ɵɵelementStart(110, "span", 153);
    i0.ɵɵtext(111);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(112, "span");
    i0.ɵɵtext(113, "/6");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(114, "div", 154);
    i0.ɵɵelementStart(115, "div", 155);
    i0.ɵɵelement(116, "div", 156);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(117, "div", 158);
    i0.ɵɵelementStart(118, "div", 151);
    i0.ɵɵelementStart(119, "div", 56);
    i0.ɵɵelement(120, "span", 159);
    i0.ɵɵelementStart(121, "span");
    i0.ɵɵelementStart(122, "span", 153);
    i0.ɵɵtext(123);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(124, "span");
    i0.ɵɵtext(125, "/4");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(126, "div", 154);
    i0.ɵɵelementStart(127, "div", 155);
    i0.ɵɵelement(128, "div", 156);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(129, "div", 151);
    i0.ɵɵelementStart(130, "div", 56);
    i0.ɵɵelement(131, "span", 160);
    i0.ɵɵelementStart(132, "span");
    i0.ɵɵelementStart(133, "span", 153);
    i0.ɵɵtext(134);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(135, "span");
    i0.ɵɵtext(136, "/4");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(137, "div", 154);
    i0.ɵɵelementStart(138, "div", 155);
    i0.ɵɵelement(139, "div", 156);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(140, "div", 139);
    i0.ɵɵelementStart(141, "div", 161);
    i0.ɵɵelementStart(142, "div", 56);
    i0.ɵɵelement(143, "span", 152);
    i0.ɵɵelementStart(144, "span");
    i0.ɵɵelementStart(145, "span", 153);
    i0.ɵɵtext(146);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(147, "span");
    i0.ɵɵtext(148, "/6");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(149, "div", 154);
    i0.ɵɵelementStart(150, "div", 155);
    i0.ɵɵelement(151, "div", 156);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(152, "div", 161);
    i0.ɵɵelementStart(153, "div", 56);
    i0.ɵɵelement(154, "span", 159);
    i0.ɵɵelementStart(155, "span");
    i0.ɵɵelementStart(156, "span", 153);
    i0.ɵɵtext(157);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(158, "span");
    i0.ɵɵtext(159, "/4");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(160, "div", 154);
    i0.ɵɵelementStart(161, "div", 155);
    i0.ɵɵelement(162, "div", 156);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(163, "div", 161);
    i0.ɵɵelementStart(164, "div", 56);
    i0.ɵɵelement(165, "span", 157);
    i0.ɵɵelementStart(166, "span");
    i0.ɵɵelementStart(167, "span", 153);
    i0.ɵɵtext(168);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(169, "span");
    i0.ɵɵtext(170, "/6");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(171, "div", 154);
    i0.ɵɵelementStart(172, "div", 155);
    i0.ɵɵelement(173, "div", 156);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(174, "div", 161);
    i0.ɵɵelementStart(175, "div", 56);
    i0.ɵɵelement(176, "span", 160);
    i0.ɵɵelementStart(177, "span");
    i0.ɵɵelementStart(178, "span", 153);
    i0.ɵɵtext(179);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(180, "span");
    i0.ɵɵtext(181, "/4");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(182, "div", 154);
    i0.ɵɵelementStart(183, "div", 155);
    i0.ɵɵelement(184, "div", 156);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(185, "tr", 92);
    i0.ɵɵelementStart(186, "td", 107);
    i0.ɵɵelementStart(187, "div", 162);
    i0.ɵɵelement(188, "fa-icon", 163);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(189, "td", 164);
    i0.ɵɵelementStart(190, "span", 165);
    i0.ɵɵtext(191, "Take the first step and find more peace!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(192, "div", 166);
    i0.ɵɵelement(193, "button", 167);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(194, WellbeingResultComponent_div_2_ng_template_194_Template, 18, 0, "ng-template", null, 168, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(17);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(18, 60, ctx_r1.currentUser == null ? null : ctx_r1.currentUser.createdDate, "dd-MM-yyyy"));
    i0.ɵɵadvance(15);
    i0.ɵɵtextInterpolate(ctx_r1.dateTakenFormatted);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("height", ctx_r1.verticalLineHeight ? (ctx_r1.verticalLineHeight == null ? null : ctx_r1.verticalLineHeight.toString(10)) + "px" : "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.srqHistoryIndex > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.srqHistoryIndex <= 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.srqHistoryIndex < ctx_r1.srqHistoryLastIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.srqHistoryIndex >= ctx_r1.srqHistoryLastIndex);
    i0.ɵɵadvance(8);
    i0.ɵɵstyleProp("background", ctx_r1.progressBackgroundColors)("width", ctx_r1.percentTotalScore + "%");
    i0.ɵɵattribute("aria-valuenow", ctx_r1.percentTotalScore);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("background", ctx_r1.numberBackgroundColor);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.totalScore);
    i0.ɵɵadvance(6);
    i0.ɵɵstyleProp("border", ctx_r1.toughPlaceBorder);
    i0.ɵɵadvance(4);
    i0.ɵɵstyleProp("border", ctx_r1.atRiskBorder);
    i0.ɵɵadvance(4);
    i0.ɵɵstyleProp("border", ctx_r1.resilientBorder);
    i0.ɵɵadvance(6);
    i0.ɵɵstyleProp("border", ctx_r1.toughPlaceBorder);
    i0.ɵɵadvance(4);
    i0.ɵɵstyleProp("border", ctx_r1.atRiskBorder);
    i0.ɵɵadvance(4);
    i0.ɵɵstyleProp("border", ctx_r1.resilientBorder);
    i0.ɵɵadvance(20);
    i0.ɵɵtextInterpolate(ctx_r1.displayedTestResult == null ? null : ctx_r1.displayedTestResult.bodyScore);
    i0.ɵɵadvance(5);
    i0.ɵɵstyleProp("width", ctx_r1.percentBodyScore + "%");
    i0.ɵɵattribute("aria-valuenow", ctx_r1.percentBodyScore);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r1.displayedTestResult == null ? null : ctx_r1.displayedTestResult.energyScore);
    i0.ɵɵadvance(5);
    i0.ɵɵstyleProp("width", ctx_r1.percentEnergyScore + "%");
    i0.ɵɵattribute("aria-valuenow", ctx_r1.percentEnergyScore);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.displayedTestResult == null ? null : ctx_r1.displayedTestResult.moodScore);
    i0.ɵɵadvance(5);
    i0.ɵɵstyleProp("width", ctx_r1.percentMoodScore + "%");
    i0.ɵɵattribute("aria-valuenow", ctx_r1.percentMoodScore);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r1.displayedTestResult == null ? null : ctx_r1.displayedTestResult.outlookScore);
    i0.ɵɵadvance(5);
    i0.ɵɵstyleProp("width", ctx_r1.percentOutlookScore + "%");
    i0.ɵɵattribute("aria-valuenow", ctx_r1.percentOutlookScore);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.displayedTestResult == null ? null : ctx_r1.displayedTestResult.bodyScore);
    i0.ɵɵadvance(5);
    i0.ɵɵstyleProp("width", ctx_r1.percentBodyScore + "%");
    i0.ɵɵattribute("aria-valuenow", ctx_r1.percentBodyScore);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r1.displayedTestResult == null ? null : ctx_r1.displayedTestResult.moodScore);
    i0.ɵɵadvance(5);
    i0.ɵɵstyleProp("width", ctx_r1.percentMoodScore + "%");
    i0.ɵɵattribute("aria-valuenow", ctx_r1.percentMoodScore);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r1.displayedTestResult == null ? null : ctx_r1.displayedTestResult.energyScore);
    i0.ɵɵadvance(5);
    i0.ɵɵstyleProp("width", ctx_r1.percentEnergyScore + "%");
    i0.ɵɵattribute("aria-valuenow", ctx_r1.percentEnergyScore);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r1.displayedTestResult == null ? null : ctx_r1.displayedTestResult.outlookScore);
    i0.ɵɵadvance(5);
    i0.ɵɵstyleProp("width", ctx_r1.percentOutlookScore + "%");
    i0.ɵɵattribute("aria-valuenow", ctx_r1.percentOutlookScore);
} }
function WellbeingResultComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 187);
    i0.ɵɵelementStart(1, "div", 188);
    i0.ɵɵelementStart(2, "fa-icon", 189);
    i0.ɵɵlistener("click", function WellbeingResultComponent_ng_template_3_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(); return ctx_r61.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 190);
    i0.ɵɵelement(4, "resources-for-help", 191);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("user", ctx_r3.currentUser);
} }
export class WellbeingResultComponent extends WellbeingResultChartComponent {
    constructor(srqService, elementRef, navbarInukaService, modalService, languageService, eventManager, trackerService, sessionStorageService, userService, domSanitizer, router, activatedRoute, accountService, sessionStorage, questionarreAnswerService, flowManagerService, wellbeingScanService) {
        super(srqService, elementRef, navbarInukaService, modalService, languageService, eventManager, trackerService, sessionStorageService, userService, domSanitizer, router, activatedRoute, accountService, sessionStorage, questionarreAnswerService, wellbeingScanService);
        this.srqService = srqService;
        this.elementRef = elementRef;
        this.navbarInukaService = navbarInukaService;
        this.modalService = modalService;
        this.languageService = languageService;
        this.eventManager = eventManager;
        this.trackerService = trackerService;
        this.sessionStorageService = sessionStorageService;
        this.userService = userService;
        this.domSanitizer = domSanitizer;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.accountService = accountService;
        this.sessionStorage = sessionStorage;
        this.questionarreAnswerService = questionarreAnswerService;
        this.flowManagerService = flowManagerService;
        this.wellbeingScanService = wellbeingScanService;
        this.modalOptions = { windowClass: 'modal-window', size: 'lg', centered: true };
        this.body = 'BODY';
        this.mood = 'MOOD';
        this.energy = 'ENERGY';
        this.purpose = 'PURPOSE';
    }
    ngOnInit() {
        super.ngOnInit();
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#FFFFFF';
        this.organizationCode = this.sessionStorageService.retrieve('organizationCode');
        this.resultProcessFinishedSubscription = this.onTotalScore.asObservable().subscribe(() => {
            var _a, _b, _c, _d;
            this.resultProcessFinishedSubscription.unsubscribe(); // unsubscribe to make sure we only log this once
            this.stage = '';
            if (this.isAtRisk) {
                this.stage = 'at_risk';
            }
            else if (this.isAtTough) {
                this.stage = 'at_tough';
            }
            else if (this.isResilient) {
                this.stage = 'resilient';
            }
            this.trackerService.sendActivity("ss_final_screen_open", {
                'self_scan_total_score': this.totalScore,
                'self_scan_stage': this.stage,
                'self_scan_body_score': (_a = this.displayedTestResult) === null || _a === void 0 ? void 0 : _a.bodyScore,
                'self_scan_energy_score': (_b = this.displayedTestResult) === null || _b === void 0 ? void 0 : _b.energyScore,
                'self_scan_mood_score': (_c = this.displayedTestResult) === null || _c === void 0 ? void 0 : _c.moodScore,
                'self_scan_purpose_score': (_d = this.displayedTestResult) === null || _d === void 0 ? void 0 : _d.outlookScore
            });
        });
    }
    ngAfterViewInit() {
        this.windowWidth = window.innerWidth;
        setTimeout(() => { this.calculateVerticalLineHeight(); }, 100);
    }
    onResize(event) {
        this.windowWidth = window.innerWidth;
        this.calculateVerticalLineHeight();
    }
    calculateVerticalLineHeight() {
        this.card1Element = document.getElementById("card-1");
        this.card2Element = document.getElementById("card-2");
        if (this.card1Element && this.card2Element) {
            this.verticalLineHeight = this.card1Element.offsetHeight + this.card2Element.offsetHeight + 60;
        }
    }
    getOrganization() {
        return this.sessionStorageService.retrieve("organization");
    }
    getTotalScore(totalScore) {
        this.totalScore = totalScore;
        if (this.totalScore > 13) {
            this.imagePathSingle = 'content/images/wellbeing/resilient-single.png';
            this.darkColor = '#D2ECE6';
            this.lightColor = '#EEF8F5';
        }
        else if (this.totalScore > 3) {
            this.imagePathSingle = 'content/images/wellbeing/at-risk-single.png';
            this.darkColor = '#EFE8C9';
            this.lightColor = '#F8F5E7';
        }
        else {
            this.imagePathSingle = 'content/images/wellbeing/tough-place-single.png';
            this.darkColor = '#EAD9E4';
            this.lightColor = '#F8F2F6';
        }
    }
    getTimeDate(timeDate) {
        this.timeDate = timeDate;
        this.timeDateString = timeDate.format('HH:mm, D MMM, YYYY');
    }
    displayInfoLarge(content) {
        this.modalService.open(content, { size: 'lg' }).result.then((result) => console.log(result));
    }
    openProgressModal() {
        this.progressModalReference = this.modalService.open(SelfScanTrendModalComponent, this.modalOptions);
        this.progressModalReference.componentInstance.selfScanModalRef = this.progressModalReference;
        this.progressModalReference.componentInstance.srqHistory = this.srqHistory;
    }
    navigateToSecondPage() {
        if (this.flowManagerService.isFlowInProgress('sss')) {
            this.wellbeingScanService.finishStandaloneSelfScanFlow(this.totalScore, this.stage, this.flowManagerService.getFlowParameter('organizationCode'), this.flowManagerService.getFlowParameter('callback'));
            // this.router.navigate(["/wellbeing-scan-standalone-callback"],
            //   {queryParams: {'score': this.totalScore, 'stage': this.stage}, skipLocationChange: true}).then();
        }
        else {
            this.router.navigate(["/wellbeing-result2", this.totalScore]).then();
        }
    }
    dismissAll() {
        this.modalService.dismissAll();
    }
    displayResourcesModal() {
        console.log(this.currentUser.region);
        this.modalService.open(this.resourcesForHelpModal, { windowClass: 'resources-for-help-modal' });
    }
    onResourceSelected($event) {
        console.log($event);
    }
    openTip(tipCategory) {
        const modalRef = this.modalService.open(TipFromCoachComponent, { size: 'md' });
        modalRef.componentInstance.tipCategory = tipCategory;
    }
}
WellbeingResultComponent.ɵfac = function WellbeingResultComponent_Factory(t) { return new (t || WellbeingResultComponent)(i0.ɵɵdirectiveInject(i1.SRQCompletedService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.NavbarInukaService), i0.ɵɵdirectiveInject(i3.NgbModal), i0.ɵɵdirectiveInject(i4.JhiLanguageService), i0.ɵɵdirectiveInject(i5.JhiEventManager), i0.ɵɵdirectiveInject(i6.TrackerService), i0.ɵɵdirectiveInject(i7.SessionStorageService), i0.ɵɵdirectiveInject(i8.UserService), i0.ɵɵdirectiveInject(i9.DomSanitizer), i0.ɵɵdirectiveInject(i10.Router), i0.ɵɵdirectiveInject(i10.ActivatedRoute), i0.ɵɵdirectiveInject(i11.AccountService), i0.ɵɵdirectiveInject(i7.SessionStorageService), i0.ɵɵdirectiveInject(i12.QuestionarreAnswerService), i0.ɵɵdirectiveInject(i13.FlowManagerService), i0.ɵɵdirectiveInject(i14.WellbeingScanService)); };
WellbeingResultComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WellbeingResultComponent, selectors: [["wellbeing-result"]], viewQuery: function WellbeingResultComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourcesForHelpModal = _t.first);
    } }, hostBindings: function WellbeingResultComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function WellbeingResultComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 2, consts: [[3, "ngSwitch"], ["class", "olha-theme pb-4 px-0 px-lg-4", 4, "ngSwitchDefault"], [4, "ngSwitchCase"], ["resourcesForHelpModal", ""], [1, "olha-theme", "pb-4", "px-0", "px-lg-4"], [1, "container-parent", "container", "first-container", "bg-2", "mb-0", "d-flex", "justify-content-center", "py-4"], [1, "row"], [1, "col", "text-center", "text-lg-right", "mb-3", "mb-lg-0"], [3, "jhiTranslate", "translateValues"], [1, "col", "text-center"], ["jhiTranslate", "wellBeingResult.yourResults", 1, "h2"], ["class", "h2 text-danger d-block d-lg-inline", "jhiTranslate", "wellBeingResult.stages.atTough.title", 4, "ngIf"], ["class", "h2 text-warning d-block d-lg-inline", "jhiTranslate", "wellBeingResult.stages.atRisk.title", 4, "ngIf"], ["class", "h2 text-success d-block d-lg-inline", "jhiTranslate", "wellBeingResult.stages.resilient.title", 4, "ngIf"], [1, "row", "pt-lg-4"], [1, "col"], [1, "row", "mx-4", "d-none", "d-lg-flex", 2, "position", "relative", "display", "flex", "justify-content", "center", "font-size", "16px"], [1, "mt-0", "mx-0", "mx-lg-5", "px-3", "py-2", "text-white", "border"], ["jhiTranslate", "wellBeingResult.stages.atTough.description", 3, "translateValues", 4, "ngIf"], ["jhiTranslate", "wellBeingResult.stages.atRisk.description", 3, "translateValues", 4, "ngIf"], ["jhiTranslate", "wellBeingResult.stages.resilient.description", 3, "translateValues", 4, "ngIf"], ["role", "button", 1, "row", "ml-1", "mr-1", 2, "position", "relative", "display", "flex", "justify-content", "center", "font-weight", "bold", "font-size", "20px"], [1, "text-danger", "mr-2", "mt-3", "pt-3"], [1, "progress", "pt-3", 2, "height", "5rem", "width", "80%", "background", "transparent"], ["class", "mt-0 text-white position-absolute d-none d-lg-block", "style", "top: -2.5rem;", 3, "style", 4, "ngIf"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar", "mt-4", 2, "border-radius", "1rem", "height", "1rem", "background", "linear-gradient(90deg, #AF3B6E 0%, #AF3B6E 17.98%, #E0CA58 24.48%, #E0CA58 70.83%, #44A38B 77.08%, #44A38B 100%)", "width", "100%"], ["class", "mt-2 text-white total-score-bubble", 3, "style", "bg-success", "bg-warning", "bg-danger", 4, "ngIf"], [1, "text-success", "ml-2", "mt-3", "pt-3"], [1, "mt-2", "d-lg-none"], [1, "row", "mx-4", "pt-1", "d-lg-none", 2, "position", "relative", "display", "flex", "justify-content", "center", "font-size", "16px"], [1, "row", "justify-content-between", "py-4", "px-5", "d-none", "d-lg-flex"], [1, "col-lg-4"], ["class", "stage-header text-danger border border-danger", "style", "background-color: #EDD3DF;", "jhiTranslate", "wellBeingResult.stages.atTough.title", 4, "ngIf"], ["class", "stage-header text-warning border border-warning", "style", "background-color: #F7EED2;", "jhiTranslate", "wellBeingResult.stages.atRisk.title", 4, "ngIf"], ["class", "stage-header text-success border border-success", "style", "background-color: #DFF1EC;", "jhiTranslate", "wellBeingResult.stages.resilient.title", 4, "ngIf"], [1, "container-parent", "container", "mb-0", "mt-0", "d-flex", "justify-content-center", "py-3"], [2, "width", "900px"], [1, "d-none", "d-lg-block"], [1, "d-flex", "justify-content-center"], ["routerLink", "/wellbeing-start", "jhiTranslate", "wellBeingResult.button.newScan", 1, "btn", "btn-secondary", "m-2"], ["jhiTranslate", "wellBeingResult.button.next", 1, "btn", "btn-primary", "m-2", 3, "click"], [1, "d-lg-none", "mt-0"], ["class", "container-parent", 4, "ngIf"], [1, "container-parent", "container", "mb-0", "mt-0", "bg-2", "py-4", "mb-4"], [1, "d-flex", "justify-content-end", "align-items-center", "mr-3"], [1, "progress-link", 3, "click"], [2, "height", "1.1rem!important", "width", "1.3rem!important"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#progress"], ["jhiTranslate", "inukaNgApp.indexUser.wellbeingResult.progress", 1, "progress-text"], [1, "row", "mt-2"], ["jhiTranslate", "wellBeingResult.moodIndicator.title"], ["jhiTranslate", "wellBeingResult.moodIndicator.description"], [1, "row", "mt-3", "px-3", "px-lg-0"], [1, "col-lg-6", "col-sm-12", "mb-3", "pr-lg-4"], [1, "row", "bg-3", "p-2", "pt-4", 2, "border-radius", "10px", "height", "14rem", "position", "relative"], [1, "col", "mx-1"], [1, "row", "m-0", "justify-content-between", "align-items-center"], [1, "mb-4"], ["jhiTranslate", "wellBeingResult.moodIndicator.body.title", 2, "font-weight", "bold", "text-transform", "uppercase"], ["icon", "info-circle", 1, "ml-2", 2, "cursor", "pointer", 3, "ngbPopover", "closeDelay"], [2, "font-weight", "bold", "font-size", "20px", 3, "ngClass"], ["bodyStagePopover", ""], [1, "row", "m-0", 2, "position", "relative", "display", "flex", "justify-content", "left"], [1, "progress", "progress-bar-horizontal-dela", 2, "height", "10px"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar", "s-resilient-details", 3, "ngClass"], [4, "ngIf"], [1, "row", "mt-3", "bg-3", "p-2", "pt-4", 2, "border-radius", "10px", "height", "14rem", "position", "relative"], ["jhiTranslate", "wellBeingResult.moodIndicator.mood.title", 2, "font-weight", "bold", "text-transform", "uppercase"], ["moodStagePopover", ""], [1, "col-lg-6", "col-sm-12", "mb-3", "pl-lg-4"], ["jhiTranslate", "wellBeingResult.moodIndicator.energy.title", 2, "font-weight", "bold", "text-transform", "uppercase"], ["energyStagePopover", ""], ["jhiTranslate", "wellBeingResult.moodIndicator.purpose.title", 2, "font-weight", "bold", "text-transform", "uppercase"], ["purposeStagePopover", ""], ["jhiTranslate", "wellBeingResult.stages.atTough.title", 1, "h2", "text-danger", "d-block", "d-lg-inline"], ["jhiTranslate", "wellBeingResult.stages.atRisk.title", 1, "h2", "text-warning", "d-block", "d-lg-inline"], ["jhiTranslate", "wellBeingResult.stages.resilient.title", 1, "h2", "text-success", "d-block", "d-lg-inline"], ["jhiTranslate", "wellBeingResult.stages.atTough.description", 3, "translateValues"], ["jhiTranslate", "wellBeingResult.stages.atRisk.description", 3, "translateValues"], ["jhiTranslate", "wellBeingResult.stages.resilient.description", 3, "translateValues"], [1, "mt-0", "text-white", "position-absolute", "d-none", "d-lg-block", 2, "top", "-2.5rem"], ["icon", "sort-down", "size", "5x"], [1, "mt-2", "text-white", "total-score-bubble"], ["jhiTranslate", "wellBeingResult.stages.atTough.title", 1, "stage-header", "text-danger", "border", "border-danger", 2, "background-color", "#EDD3DF"], ["jhiTranslate", "wellBeingResult.stages.atRisk.title", 1, "stage-header", "text-warning", "border", "border-warning", 2, "background-color", "#F7EED2"], ["jhiTranslate", "wellBeingResult.stages.resilient.title", 1, "stage-header", "text-success", "border", "border-success", 2, "background-color", "#DFF1EC"], [1, "container-parent"], [1, "container", "mt-0", "py-1", "mb-4", "q17-container", "d-flex", "justify-content-between"], ["icon", "info-circle", 1, "purple-info"], ["jhiTranslate", "wellBeingResult.q17AlertBeforeLink"], ["jhiTranslate", "wellBeingResult.q17AlertLink", 3, "click"], ["jhiTranslate", "wellBeingResult.q17AlertAfterLink"], [1, "mt-2"], ["jhiTranslate", "wellBeingResult.moodIndicator.body.description"], [1, "text-justify", "mt-3", 3, "jhiTranslate"], [1, "d-flex", "justify-content-start", "align-items-center", "mt-3", "mb-3", 2, "position", "absolute", "top", "90px"], ["jhiTranslate", "wellBeingResult.moodIndicator.body.bodyActive", 1, "text-justify", "tip-text"], ["jhiTranslate", "wellBeingResult.moodIndicator.readNow", 1, "text-justify", "read-now", 3, "click"], ["jhiTranslate", "wellBeingResult.moodIndicator.mood.description"], ["jhiTranslate", "wellBeingResult.moodIndicator.mood.stayInMood", 1, "text-justify", "tip-text"], ["jhiTranslate", "wellBeingResult.moodIndicator.energy.description"], ["jhiTranslate", "wellBeingResult.moodIndicator.energy.energyHigh", 1, "text-justify", "tip-text"], ["jhiTranslate", "wellBeingResult.moodIndicator.purpose.description"], ["jhiTranslate", "wellBeingResult.moodIndicator.purpose.understandPurpose", 1, "text-justify", "tip-text"], [1, "page-single", 2, "background-color", "white", "margin-top", "40px"], [1, "card-body", "col-xs-12", "col-sm-12", "col-md-10", "col-lg-8", "col-xl-6", 2, "padding", "10px!important", "margin-top", "30px"], [1, "journey-table", "mt-2"], [1, "journey-row-icon"], [1, "align-items-center", "score-bubble", 2, "background-color", "#4AB197"], ["icon", "check", 2, "color", "white", "font-size", "24px"], ["jhiTranslate", "inukaNgApp.inukaJourney.welcome", 1, "journey-row-header-dela", 2, "padding-left", "3px!important"], [1, "journey-row-text"], ["jhiTranslate", "inukaNgApp.inukaJourney.registeredOn"], [1, "vertical-line", 2, "height", "30px"], ["jhiTranslate", "inukaNgApp.inukaJourney.selfScan", 1, "journey-row-header-dela", 2, "padding-left", "3px!important"], ["jhiTranslate", "inukaNgApp.inukaJourney.resultsOn"], ["id", "vertical-line-row"], [1, "vertical-line"], ["id", "card-1", 1, "card", "mt-2"], [1, "row", "m-2", "justify-content-between", 2, "color", "#46a28c"], ["role", "button", 3, "click", 4, "ngIf"], ["style", "color: white;", 4, "ngIf"], [1, "mt-3", "mb-3"], ["jhiTranslate", "inukaNgApp.inukaJourney.yourResults", 2, "text-align", "center", "font-weight", "bold"], ["role", "button", 1, "row", "ml-1", "mr-1", 2, "position", "relative", "display", "flex", "justify-content", "center", "font-weight", "bold", "font-size", "20px", 3, "click"], [2, "font-size", "16px", "font-weight", "bold", "margin", "3px 3px 3px 0", "color", "#90597b"], [1, "progress", "progress-bar-horizontal"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar"], [1, "number-circle"], [2, "font-size", "16px", "font-weight", "bold", "margin", "3px 0 3px 3px", "color", "#46a28c"], [1, "d-none", "d-sm-block"], [1, "m-3", "justify-content-between", "row"], [2, "border-radius", "5px", "padding", "10px 5px 10px 5px!important", "width", "32%"], ["jhiTranslate", "inukaNgApp.indexUser.toughPlace1row", 1, "dela-category-header", 2, "background-color", "#b793a9", "color", "#90597b"], ["jhiTranslate", "inukaNgApp.indexUser.toughPlaceTextDela", 2, "margin", "5px"], ["jhiTranslate", "inukaNgApp.indexUser.atRisk1row", 1, "dela-category-header", 2, "background-color", "#e8d78b", "color", "#bfa844"], ["jhiTranslate", "inukaNgApp.indexUser.atRiskTextDela", 2, "margin", "5px"], ["jhiTranslate", "inukaNgApp.indexUser.resilient1row", 1, "dela-category-header", 2, "background-color", "#87c3b4", "color", "#46a28c"], ["jhiTranslate", "inukaNgApp.indexUser.resilientTextDela", 2, "margin", "5px"], [1, "d-sm-none"], [1, "m-3", "justify-content-between"], [2, "border-radius", "5px", "padding", "10px 5px 10px 5px!important", "width", "100%"], ["id", "card-2", 1, "card", "mt-2", "mb-4"], [1, "m-4"], ["jhiTranslate", "inukaNgApp.inukaJourney.moodIndicator"], [1, "row", 2, "font-size", "14px", "margin", "0 0 10px 0"], [2, "width", "6%"], ["icon", "info-circle", 2, "color", "grey"], [2, "width", "93%"], ["jhiTranslate", "inukaNgApp.inukaJourney.moodIndicatorText", 2, "color", "grey"], [1, "row", "justify-content-between", 2, "margin", "0 0 10px 0"], [2, "width", "45%"], ["jhiTranslate", "inukaNgApp.indexUser.body", 2, "font-weight", "bold", "text-transform", "uppercase"], [2, "font-weight", "bold", "font-size", "20px"], [1, "row", "m-0", 2, "position", "relative", "display", "flex", "justify-content", "left", "font-weight", "bold", "font-size", "20px"], [1, "progress", "progress-bar-horizontal-dela", 2, "height", "16px"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar", "s-resilient-details", 2, "background-color", "#46a28c"], ["jhiTranslate", "inukaNgApp.indexUser.energy", 2, "font-weight", "bold", "text-transform", "uppercase"], [1, "row", "m-0", "justify-content-between", 2, "margin-top", "10px!important"], ["jhiTranslate", "inukaNgApp.indexUser.mood", 2, "font-weight", "bold", "text-transform", "uppercase"], ["jhiTranslate", "inukaNgApp.indexUser.purpose", 2, "font-weight", "bold", "text-transform", "uppercase"], [2, "margin-top", "10px!important"], [1, "align-items-center", "score-bubble", 2, "background-color", "#efe199"], ["icon", "calendar-alt", 2, "font-size", "24px", "color", "white"], [2, "padding-left", "5px!important"], ["jhiTranslate", "inukaNgApp.inukaJourney.firstStep", 1, "journey-row-header-dela"], [1, "mb-3", 2, "text-align", "center"], ["jhiTranslate", "inukaNgApp.indexUser.next", "routerLink", "/wellbeing-result-dela-2", 1, "btn-2", "btn-primary", 2, "background-color", "#4AB197", "border-radius", "18px", "width", "120px", "padding-top", "3px!important", "padding-bottom", "3px!important", "text-align", "center", "text-transform", "uppercase"], ["wellbeingInfoModal", ""], ["role", "button", 3, "click"], ["icon", "arrow-left"], ["jhiTranslate", "inukaNgApp.inukaJourney.previousScan", 2, "padding-left", "3px", "font-weight", "bold"], [2, "color", "white"], ["jhiTranslate", "inukaNgApp.inukaJourney.nextScan", 2, "padding-right", "3px", "font-weight", "bold"], ["icon", "arrow-right"], [1, "modal-body", 2, "overflow-wrap", "break-word"], [2, "display", "block", "margin", "0 auto"], ["align", "center", 1, "score-board-details", "mb-2", 2, "background-color", "white"], ["jhiTranslate", "inukaNgApp.indexUser.resilient", 1, "score-details", "align-middle", "resilient-indicator"], [1, "category-text"], ["jhiTranslate", "inukaNgApp.indexUser.resilientText"], ["jhiTranslate", "inukaNgApp.indexUser.atRisk", 1, "score-details", "align-middle", "at-risk-indicator"], ["jhiTranslate", "inukaNgApp.indexUser.atRiskText"], ["jhiTranslate", "inukaNgApp.indexUser.toughPlace", 1, "score-details", "align-middle", "tough-place-indicator"], ["jhiTranslate", "inukaNgApp.indexUser.toughPlaceText"], [2, "text-align", "center"], ["role", "button", "jhiTranslate", "inukaNgApp.indexUser.done", 1, "btn-2", "btn-primary", "find-coach", 2, "width", "30%!important", 3, "click"], [1, "olha-theme", "resources-content"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "mt-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", "pt-0"], [3, "user"]], template: function WellbeingResultComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, WellbeingResultComponent_div_1_Template, 140, 80, "div", 1);
        i0.ɵɵtemplate(2, WellbeingResultComponent_div_2_Template, 196, 63, "div", 2);
        i0.ɵɵtemplate(3, WellbeingResultComponent_ng_template_3_Template, 5, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngSwitch", ctx.getOrganization());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngSwitchCase", "dela");
    } }, directives: [i15.NgSwitch, i15.NgSwitchDefault, i15.NgSwitchCase, i16.JhiTranslateDirective, i15.NgIf, i10.RouterLink, i17.FaIconComponent, i3.NgbPopover, i15.NgClass, i18.ResourcesForHelpComponent], pipes: [i15.DatePipe], styles: [".container[_ngcontent-%COMP%]{margin:90px auto 295px;height:auto !important;width:auto;max-width:1169px !important;padding-top:30px;text-align:center}.first-container[_ngcontent-%COMP%]{margin:90px 20px 10px !important}.find-coach[_ngcontent-%COMP%]{font-size:12px;background-color:#000;border-radius:40px;margin:10px auto;width:40%;padding:5px !important}.under-image-text[_ngcontent-%COMP%]{font-size:10px;font-style:italic;margin-top:10px}.title[_ngcontent-%COMP%]{text-transform:uppercase;color:#000;text-decoration:none !important}.person-story[_ngcontent-%COMP%]{color:#44a38c;font-style:italic;font-weight:lighter;-webkit-text-decoration:underline dotted #44a38c;text-decoration:underline dotted #44a38c;text-align:center;font-size:1.4rem}.inuka-home[_ngcontent-%COMP%]{font-size:12px;background-color:#fff !important;color:#000 !important;border-color:#000 !important;border-radius:40px;margin:10px auto;width:40%;padding:5px !important}.total-score-bubble[_ngcontent-%COMP%]{font-size:1.4rem;padding-top:1.4rem;display:inline;text-align:center;position:absolute;height:3rem;width:3rem;z-index:130;border-radius:3rem}.progress-link[_ngcontent-%COMP%]{margin-left:.5rem;color:#44a38d}.progress-text[_ngcontent-%COMP%]{color:#44a38d;font-weight:bold;display:none;padding-left:3px}.container-parent[_ngcontent-%COMP%]{margin:0 20px}.q17-container[_ngcontent-%COMP%]{text-align:left;border:1px solid #af3b6e;border-radius:12px}.purple-info[_ngcontent-%COMP%]{margin-right:15px;color:#af3b6e;font-size:18px}.resources-content[_ngcontent-%COMP%]{padding:0 20px 20px 20px}.resources-for-help-modal[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{height:auto}@media(min-width: 576px){.category-text[_ngcontent-%COMP%]{font-size:.6rem}.progress-text[_ngcontent-%COMP%]{display:inline}}@media(min-width: 768px){.category-text[_ngcontent-%COMP%]{font-size:.7rem}}@media(min-width: 992px){.category-text[_ngcontent-%COMP%]{font-size:.7rem}.container-parent[_ngcontent-%COMP%]{margin:0 auto}}@media(min-width: 1200px){.category-text[_ngcontent-%COMP%]{font-size:.8rem}.first-container[_ngcontent-%COMP%]{margin:90px auto 30px !important}}.stage-desc-box[_ngcontent-%COMP%]{height:80%}.stage-header[_ngcontent-%COMP%]{background-color:#f7f4eb;padding:5px 0 5px 0;border-radius:4px;position:absolute;top:-1rem;left:0;right:0;margin-left:auto;margin-right:auto;width:11rem;font-weight:bold;border-width:1px !important}.stage-desc-box.active[_ngcontent-%COMP%]{background-color:#fff;opacity:1}.stage-desc-box.active[_ngcontent-%COMP%]   .stage-header[_ngcontent-%COMP%]{border-width:1px !important;background-color:#fff}.progress[_ngcontent-%COMP%]{background-color:#e1e1e1}.tip-text[_ngcontent-%COMP%]{font-weight:600 !important;margin-right:5px}.read-now[_ngcontent-%COMP%]{font-weight:600 !important;color:#44a38b;text-decoration:underline;cursor:pointer}", ".score-board-details[_ngcontent-%COMP%]{background-color:#f8f7f2;border-radius:4rem;border-spacing:.4rem;border-collapse:separate;margin:auto 0}.equal-distance-h[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.equal-distance-v[_ngcontent-%COMP%]{display:flex;justify-content:space-between;flex-direction:column}.score-details[_ngcontent-%COMP%]{width:4rem;height:4rem;font-size:8px;background-color:#fff;text-transform:uppercase;border-radius:100%;font-weight:bold;color:#f8f7f2;text-align:center}.category-details[_ngcontent-%COMP%]{width:4rem;height:4rem;background-color:#fff;text-transform:uppercase;border-radius:100%;border:1px solid #000;font-size:10px;font-weight:bold;color:#000;text-align:center}.swipe-arrow[_ngcontent-%COMP%]{width:2rem;height:2rem;margin:auto 0}.progress-bar-horizontal[_ngcontent-%COMP%]{width:80%;text-align:center;margin-top:8px;z-index:130}.progress-bar-horizontal-dela[_ngcontent-%COMP%]{width:100%;text-align:center;z-index:130;border-radius:8px}.progress-bar[_ngcontent-%COMP%]{z-index:120}.progress-bar-vertical[_ngcontent-%COMP%]{z-index:130;margin-bottom:5px}.progress-bar-vertical[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{border-radius:20px 20px 0 0 !important}.vertical-bar[_ngcontent-%COMP%]{height:20px;z-index:110}.number-circle[_ngcontent-%COMP%]{width:16px;height:16px;padding-top:8px;text-align:center;color:#fff}.category-header[_ngcontent-%COMP%]{color:#000;text-transform:uppercase;text-align:center;font-size:.5rem}.find-coach[_ngcontent-%COMP%]{font-size:12px;background-color:#000 !important;color:#fff !important;border-radius:40px;margin:10px auto;width:40%;padding:5px !important}.inuka-home[_ngcontent-%COMP%]{font-size:12px;background-color:#fff !important;color:#000 !important;border-color:#000 !important;border-radius:40px;margin:10px auto;width:40%;padding:5px !important}.title[_ngcontent-%COMP%]{text-transform:uppercase;color:#000;text-decoration:none !important}.person-story[_ngcontent-%COMP%]{color:#44a38c;font-style:italic;font-weight:lighter;-webkit-text-decoration:underline dotted #44a38c;text-decoration:underline dotted #44a38c;text-align:center;font-size:1.4rem}.under-image-text[_ngcontent-%COMP%]{font-size:9px;font-style:italic;margin-top:10px}.s-resilient-details[_ngcontent-%COMP%]{background-color:#a9d3c7;color:#000}.s-at-risk-details[_ngcontent-%COMP%]{background-color:#efe199;color:#000}.s-in-a-bad-place-details[_ngcontent-%COMP%]{background-color:#b894aa;color:#000}.s-resilient-trend[_ngcontent-%COMP%]{background-color:#a9d3c7;color:#fff}.s-at-risk-trend[_ngcontent-%COMP%]{background-color:#ead88c;color:#fff}.s-in-a-bad-place-trend[_ngcontent-%COMP%]{background-color:#b894aa;color:#fff}.dela-category-header[_ngcontent-%COMP%]{margin:5px 5px 5px 2px;padding:5px;text-transform:uppercase;font-weight:bold;border-radius:5px;line-height:38px}.journey-table[_ngcontent-%COMP%]{width:100%;margin-bottom:1rem;color:#212529}.journey-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .journey-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:center}.journey-table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6}.journey-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%]{border-top:2px solid #dee2e6}.journey-table[_ngcontent-%COMP%]   .thead-dark[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#fff;background-color:#343a40;border-color:#454d55}.journey-table[_ngcontent-%COMP%]   .thead-light[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.journey-table[_ngcontent-%COMP%]{border-collapse:collapse !important}.journey-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .journey-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{background-color:#fff !important}.journey-table[_ngcontent-%COMP%]   .thead-dark[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:inherit;border-color:#dee2e6}.journey-row-icon[_ngcontent-%COMP%]{width:30px !important;text-align:left;vertical-align:center}.journey-row-header[_ngcontent-%COMP%]{text-align:left;vertical-align:center;color:#000;padding-left:3px !important;font-size:18px;font-weight:bold}.journey-row-header-dela[_ngcontent-%COMP%]{text-align:left;vertical-align:center;color:#000;font-size:16px;font-weight:bold}.journey-row-text[_ngcontent-%COMP%]{text-align:left;vertical-align:center;color:gray;padding-left:3px !important;font-size:14px}.vertical-line[_ngcontent-%COMP%]{background-color:#4ab197;width:2px;height:100%;margin-left:calc(50% - 1px)}.score-bubble[_ngcontent-%COMP%]{width:2.5rem;height:2.5rem;border-radius:50%;line-height:2.5rem;text-align:center;z-index:10}.default-icon-text[_ngcontent-%COMP%]{background-color:#fff;color:#4ab197;border:2px solid #4ab197;font-weight:bold}.empty-td[_ngcontent-%COMP%]{border-top:1px dashed #dee2e6}.iframe-container[_ngcontent-%COMP%]{position:relative;overflow:hidden;width:100%;padding-top:56.25%;font-size:14px}.responsive-iframe[_ngcontent-%COMP%]{position:absolute;top:0;left:0;bottom:0;right:0;width:100%;height:100%;border:1px solid gray}.blob-text[_ngcontent-%COMP%]{font-size:2rem}.category-header[_ngcontent-%COMP%]{font-size:.5rem}.category-text[_ngcontent-%COMP%]{font-size:.7rem}.score-board-details[_ngcontent-%COMP%]{border-radius:3rem;border-spacing:.3rem}.score-details[_ngcontent-%COMP%]{width:4rem;height:4rem;font-size:10px}.swipe-arrow[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem}.progress-bar-vertical[_ngcontent-%COMP%]{width:2.5rem}.blob-text[_ngcontent-%COMP%]{font-size:1rem}@media(min-width: 576px){.category-header[_ngcontent-%COMP%]{font-size:.5rem}.category-text[_ngcontent-%COMP%]{font-size:.7rem}.score-board-details[_ngcontent-%COMP%]{border-radius:3rem;border-spacing:.3rem}.score-details[_ngcontent-%COMP%]{width:4rem;height:4rem;font-size:10px}.swipe-arrow[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem}.progress-bar-vertical[_ngcontent-%COMP%]{width:2.5rem}}@media(min-width: 768px){.category-header[_ngcontent-%COMP%]{font-size:.39rem}.category-text[_ngcontent-%COMP%]{font-size:.8rem}.score-board-details[_ngcontent-%COMP%]{border-radius:3rem;border-spacing:.3rem}.score-details[_ngcontent-%COMP%]{width:2.8rem;height:2.8rem;font-size:9px}.swipe-arrow[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem}.progress-bar-vertical[_ngcontent-%COMP%]{width:1.8rem}}@media(min-width: 992px){.category-header[_ngcontent-%COMP%]{font-size:.44rem}.category-text[_ngcontent-%COMP%]{font-size:.8rem}.score-board-details[_ngcontent-%COMP%]{border-radius:3.5rem;border-spacing:.35rem}.score-details[_ngcontent-%COMP%]{width:2.8rem;height:2.8rem;font-size:9px}.swipe-arrow[_ngcontent-%COMP%]{width:1.6rem;height:1.6rem}.progress-bar-vertical[_ngcontent-%COMP%]{width:2.2rem}}@media(min-width: 1200px){.category-header[_ngcontent-%COMP%]{font-size:.49rem}.category-text[_ngcontent-%COMP%]{font-size:.8rem}.score-board-details[_ngcontent-%COMP%]{border-radius:4rem;border-spacing:.4rem}.score-details[_ngcontent-%COMP%]{width:3.5rem;height:3.5rem;font-size:10px}.swipe-arrow[_ngcontent-%COMP%]{width:2rem;height:2rem}.progress-bar-vertical[_ngcontent-%COMP%]{width:2.5rem}}"] });
